import React, { useEffect, useRef, useState } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
// import { Users, Star } from "react-feather";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faDoorOpen,
  faEdit,
  faPlus,
  faSort,
  faTowerObservation,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import clientlogo from "../assets/img/na.png";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate, Link } from "react-router-dom";
import ReactDOM from "react-dom";
import client from "../assets/img/na.png";
import vaPng from "../assets/img/va.png";
import userPng from "../assets/img/ua.png";
import building from "../assets/img/building.png";
import office from "../assets/img/office.png";
import apartment from "../assets/img/apartment.png";
import gate from "../assets/img/gate.png";
import Menus from "./menus";
import Noticemanagement from "./Noticemanagement";
// import NoticeApproval from "./NoticeApproval";
import Building from "./building";
import Tower from "./tower";
import Flat from "./flat";
import Gate from "./Gate";
import NoticeApproval from "./NoticeApproval";
import VehicleApproval from "./vehicleApproval";
import UserApproval from "./UserApproval";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

import NoInternet from "./Nointernet";
import Department from "./Department";
import SocietyRole from "./SocietyRole";


function Approval() {
  const history = useNavigate();
  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabChange = (tab) => {
    localStorage.setItem("lastTabApproval", tab)
    setActiveTab(tab);
  };
  const [reset, setReset] = useState(0);
  const [showMobileSubMenu, setShowMobileSubMenu] = useState(false)

  useEffect(() => {
    const storedUsername = localStorage.getItem('userData');
    const myUserData = JSON.parse(storedUsername);
    console.log("useEffect Local storage name", storedUsername)
    if (storedUsername) {
      // If the username is present, redirect to the dashboard
      if(myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Support Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator"){
        if(myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Super Admin"){
          history('/Approval');
          return
        }else{
          history('/Dashboard');
          return
        } 
        
      }else{
        history('/Dashboard');
        console.log("useEffect Local storage Yes")
        return
      }  
      
    }
    else if (storedUsername === null) {
      history('/');
      console.log("useEffect Local storage No")
    }
  }, [history]);

  useEffect(() => {
    localStorage.setItem("lastTab", "tab1")
    localStorage.setItem("lastTabManagent", "tab1")
    localStorage.setItem("lastTabUtility", "tab1")
    const lastTab = localStorage.getItem("lastTabApproval");
    if (!lastTab) {
      setActiveTab("tab1")
    }
    else {
      setActiveTab(lastTab)
    }

  }, [])

  return (
    <>
      <Menus />
      <section className="tabular_intergration">
        <div className="tab-container">
          <div className="UnderBox-Shadow">
            <div className="container-fluid py-0 px-0">
              <div className="row">
                <div className="col-lg-12 col-dm-12 col-sm-12 col-12">
                  <div className="tabs">
                    <button
                      className={activeTab === "tab1" ? "active-tab" : ""}
                      onClick={() => handleTabChange("tab1")}
                    >
                      <img src={userPng} className="img" style={{ width: "21px" }} />{" "}
                      User Approval
                      
                    </button>
                    <button
                      className={activeTab === "tab2" ? "active-tab" : ""}
                      onClick={() => handleTabChange("tab2")}
                    >
                      <img src={vaPng} className="img" style={{ width: "21px" }} />{" "}
                      Vehicle Approval
                    </button>
                    <button
                      className={activeTab === "tab3" ? "active-tab" : ""}
                      onClick={() => handleTabChange("tab3")}
                    >
                      <img src={client} className="img" style={{ width: "21px" }} />{" "}
                      Notice Approval
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="mobileViewSubMenu" style={{ width: "100%" }}>
        <div className="rebon" onClick={() => { setShowMobileSubMenu(!showMobileSubMenu) }}>
          {showMobileSubMenu === false && <FaChevronDown className="rebonChevron" size="12px" />}
          {showMobileSubMenu === true && <FaChevronUp className="rebonChevron" size="12px" />}
        </div>
        <div className={`submenu ${showMobileSubMenu ? "open" : "closed"}`}>
          <div className="row">
            <div className="col-lg-12 col-dm-12 col-sm-12 col-12">
              <div className="tabs">
                <button
                  className={activeTab === "tab1" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab1")}
                >
                  User Approval
                </button>
                <button
                  className={activeTab === "tab2" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab2")}
                >
                   
                  Vehicle Approval
                </button>
                <button
                  className={activeTab === "tab3" ? "active-tab" : "subfeildbtn"}
                  onClick={() => handleTabChange("tab3")}
                >
                  Notice Approval
                </button>
                


              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="OneClr_apply">
        <div className="container-fluid">
          <div className='row'>
            <div className="col-12 ">


              {activeTab === "tab1" && (
                <div>
                    <UserApproval />
                </div>
              )}
              {activeTab === "tab2" && (
                <div>
                  <VehicleApproval />
                </div>
              )}
              {activeTab === "tab3" && (
                <div>
                  <NoticeApproval />
                </div>
              )}

              {/* {activeTab === "tab2" && (
                <div>
                  <NoticeApproval />
                </div>
              )}
   */}

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Approval;
